import type { Context } from 'react';
import { createContext, useContext } from 'react';

import type { AuthContextType } from './types';

export const AuthContext = createContext<AuthContextType | null>(null);

export function useAuth() {
	const context = useContext(AuthContext as Context<AuthContextType | null>);
	if (!context) throw new Error('useAuth must be used within an AuthProvider');
	return context;
}
